export default function IconWarming1({ color = "white", size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 10 9"
      fill="none"
    >
      <circle cx="5" cy="4.5" r="4.5" fill="#FF5B21" />
    </svg>
  );
}
